import { z } from 'zod/v4';
import type { $ZodEnumParams } from 'zod/v4/core';

/**
 * A native enum validator that will accept any string as an input.
 *
 * This is crucial for interop with Prisma Enums. We use the inferred input type
 * of zod schemas as a type constraint for action function return values so we
 * need the flexibility of accepting any string.
 *
 * @maybe-deprecate use `z.enum(EnumLike)` directly, instead
 */
export function stringToEnum<
  T extends Readonly<Record<string, string | number>>,
>(values: T, params?: $ZodEnumParams) {
  return z
    .string()
    .trim()
    .pipe(z.any().pipe(z.enum(values, params)));
}
